import React from 'react';
export function CTABanner({
  onNavigate,
  onOpenQuote
}: {
  onNavigate: (page: string) => void;
  onOpenQuote?: () => void;
}) {
  return <section className="py-20 bg-white" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="bg-primary rounded-3xl p-8 md:p-16 relative overflow-hidden shadow-2xl" data-id="element-40">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-41"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent/10 rounded-full blur-3xl -translate-y-1/2 -translate-x-1/2" data-id="element-42"></div>
          <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-43">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-44">
              Ready to reduce your telecom spend by 30%?
            </h2>
            <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-45">
              Get a free expense analysis in just 30 minutes. We'll show you
              exactly where you're overspending and how much you can save.
            </p>
            <button onClick={() => onOpenQuote?.()} className="bg-accent hover:bg-accent-dark text-white px-10 py-5 rounded-full font-bold text-xl transition-all shadow-xl shadow-accent/20" data-id="element-46">
              Get Your Free Audit Now
            </button>
          </div>
        </div>
      </div>
    </section>;
}